import { createRoute, redirect } from "@tanstack/react-router";

import { isMeaningfulGigsRole } from "../../utils/auth";
import { authLayoutRoute } from "../auth-layout/route";
import { roiRoute } from "../roi/route";
import { ticketsRoute } from "../tickets/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    throw redirect({
      to: isMeaningfulGigsRole() ? roiRoute.to : ticketsRoute.to,
    });
  },
});
